import { textContent } from "standard/css";

let url;

function globalCSSStyleSheetUrl() {
  return (url ??= window.URL.createObjectURL(
    new Blob([textContent.join(" ")], { type: "text/css" }),
  ));
}

export default globalCSSStyleSheetUrl;
